import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

// SERVICES
import { IPickingItemsResponse } from '../../../../order/interfaces/order-sales.interface';
import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class OrderPostedApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getOrderPostedPickingItems(
    salesOrderId :number,
  ) :Observable<IPickingItemsResponse> {
    return this.apiService.get(
      `${this.environment.urlV1}/sales/shipstation_sales/${salesOrderId}/picking_items`,
    );
  }

  getById(data :{
    id :number;
    params ?:{ [param :string] :string | string[] };
  }) :Observable<any> {
    const { id, params } = data;

    return this.apiService.get(`${this.environment.urlV2}/orders/sales/${id}`, {
      params,
    });
  }

  delete(salesOrderId :number, payload ?:{ rollbackInv :number }) :Observable<any> {
    return this.apiService.delete(
      `${this.environment.urlV1}/sales/shipstation_sales/${salesOrderId}/delete`,
      payload,
    );
  }
}
